import React from 'react';

export interface FormContainerFooterProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    /**  Hide the footer. Can be useful for saving states */
    hide?: boolean;
}

const FormContainerFooter = ({ children, hide = false, ...rest }: FormContainerFooterProps): JSX.Element | null => {
    if (hide) {
        return null;
    }

    return (
        <footer className="footer" {...rest}>
            <div className="footer-content">{children}</div>
        </footer>
    );
};

export default FormContainerFooter;
